import { useEffect, useState } from 'react';
import './Telegram.scss';
import api from '../../js/api';
import Modal from '../../components/Modal/Modal';
import Button from '../../components/Button/Button';

function BotChats({ botId, refreshKey }) {
    const [chats, setChats] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        api.get(`/user/telegram/bots/${botId}`).then((res) => {
            if (res.error) {
                setError(res.error);
            } else {
                setChats(res.chats || []);
            }
            setLoading(false);
        });
    }, [botId, refreshKey]);

    if (loading) {
        return <p>Cargando...</p>;
    }

    if (error) {
        return <p>Error loading chats: {error}</p>;
    }

    if (!chats || chats.length === 0) {
        return <p>No chats found for this bot.</p>;
    }

    return (
        <div className='flex gap flex-column margin-left'>
            <h4>Chats:</h4>
            {chats.map((chat) => (
                <div key={chat.id} className='flex flex-space-between flex-align-center width-100'>
                    <p>{chat.name} ({chat.chat_id})</p>
                    <Button class_="red white-text margin-30-left" onClick={async () => {
                        const confirmDelete = window.confirm(`Are you sure you want to delete the chat "${chat.name}" (${chat.id})?`);
                        if (!confirmDelete) {
                            return;
                        }

                        const res = await api.delete(`/user/telegram/bots/${botId}/chats/${chat.id}`);
                        if (!res.error) {
                            setChats(chats.filter(c => c.id !== chat.id));
                            alert('Chat deleted successfully!');
                        }
                    }} >
                        <span className='material-icon'>delete</span>
                    </Button>
                </div>
            ))}
        </div>
    );
}

export default function Telegram() {
    const [bots, setBots] = useState([]);
    const [refreshKeys, setRefreshKeys] = useState({});

    const refreshBotChats = (botId) => {
        setRefreshKeys(prev => ({ ...prev, [botId]: (prev[botId] || 0) + 1 }));
    };

    useEffect(() => {
        api.get('/user/telegram/bots').then((data) => {
            setBots(data);
        });
    }, []);

    const refreshBots = () => {
        api.get('/user/telegram/bots').then((data) => {
            setBots(data);
        });
    }

    return (
        <div id="telegram">
            <div className='centered-container'>
                <h2>Telegram</h2>
                <br />
                <div>
                    {(!bots || bots.length === 0) && <p>No bots found.</p>}
                    {bots.map((bot) => (
                        <Modal key={bot.id} text={bot.name}>
                            <div className='flex flex-align-center gap'>
                                <span className='material-icon'>smart_toy</span>
                                <h3>{bot.name}</h3>
                            </div>
                            <br />
                            <BotChats botId={bot.id} refreshKey={refreshKeys[bot.id] || 0} />
                            <br />
                            <hr style={{ width: '100%' }} />
                            <br />

                            <div className='flex gap flex-align-center flex-space-between'>
                                <Button text="Add new Chat" onClick={async () => {
                                    const id = prompt('Enter the Chat ID to add:', '');
                                    if (id === null) {
                                        return;
                                    }
                                    if (!id) {
                                        alert('Chat ID is required.');
                                        return;
                                    }

                                    const res = await api.post(`/user/telegram/bots/${bot.id}/chats`, { chat_id: id });
                                    if (!res.error) {
                                        refreshBotChats(bot.id);
                                        alert('Chat added successfully!');
                                    }
                                }} />
                                <Button text="Delete Bot" onClick={async () => {
                                    const confirmDelete = window.confirm(`Are you sure you want to delete the bot "${bot.name}"?`);
                                    if (!confirmDelete) {
                                        return;
                                    }

                                    const res = await api.delete(`/user/telegram/bots/${bot.id}`);
                                    if (!res.error) {
                                        setBots(bots.filter(b => b.id !== bot.id));
                                        alert('Bot deleted successfully!');
                                    }
                                }} class_="red white-text" />
                            </div>

                        </Modal>
                    ))}
                </div>
                <Button text="Add New Bot" onClick={async () => {
                    const botToken = prompt('Enter the Telegram Bot Token:', '');
                    if (botToken === null) {
                        return;
                    }
                    if (botToken && botToken.trim() === '') {
                        alert('Bot token is required.');
                        return;
                    }

                    const res = await api.post('/user/telegram/bots', { token: botToken });
                    if (!res.error) {
                        alert('Bot added successfully!');
                        refreshBots();
                    }
                }} />
            </div>
        </div>
    );
}